import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addOrUpdateDigitalAgronomistPreferences } from "services";

import { ADD_OR_UPDATE_DIGITAL_AGRONOMIST_PREFERENCES, GET_DIGITAL_AGRONOMIST_PREFERENCES } from "consts";

export const useAddOrUpdateDigitalAgronomistPreferences = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_OR_UPDATE_DIGITAL_AGRONOMIST_PREFERENCES],
    mutationFn: addOrUpdateDigitalAgronomistPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_DIGITAL_AGRONOMIST_PREFERENCES] });
    },
  });
};
